import React from 'react'
import './anchor.scss'

const Anchor = ({ target, className, href, children }) => {
	return target !== undefined ? (
		<a
			className={`link ${className !== undefined && className}`}
			href={href}
			target="_blank"
			rel="noopener noreferrer"
		>
			{children}
		</a>
	) : (
		<a className={`link ${className !== undefined && className}`} href={href}>
			{children}
		</a>
	)
}

export default Anchor
